import { FC, useMemo, useCallback } from 'react';
import OutLine from './outline';
import SpeedLine from './speedLine';

import { DriverData } from '../../types/common';
import DownloadIcon from '../Icons/DownloadIcon';

import './index.css';

interface TachographChartProps {
  mileage: Record<string, number>;
  speed: Record<string, number>;
  driverData?: DriverData | DriverData[];
  isToday: boolean;
}

const TachographChart: FC<TachographChartProps> = ({ mileage, speed, driverData, isToday }) => {
  const isEmptyMileage = useMemo(() => {
    return !mileage || !Object.keys(mileage).length
  }, [mileage])

  const isEmptySpeed = useMemo(() => {
    return !speed || !Object.keys(speed).length
  }, [speed])

  const handleDownloadBoth = useCallback(() => {
    const files = [
      { value: mileage, name: 'mileage.json' },
      { value: speed, name: 'speed.json' }
    ];

    for (const file of files) {
      try {
        const data = file.value;
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = file.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
      } catch (e) {
        alert(`${file.name} 下載失敗`);
      }
    }
  }, [mileage, speed]);

  return (
    <div className="tachograph-chart-container">
      <OutLine />
      {
        !isEmptyMileage && !isEmptySpeed && (
          <SpeedLine speed={speed} mileage={mileage} driverData={driverData} isToday={isToday} />
        )
      }
      <div className="tachograph-chart-container__download-icon" onClick={handleDownloadBoth}>
        <DownloadIcon size={24} color="#ccc" />
      </div>
    </div>
  )
}

export default TachographChart;